import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Location } from "@angular/common";
import Swal from "sweetalert2";

import { InvestorType } from "src/app/shared/enum/investor-type.enum";

@Component({
  selector: "app-selecao-tipo-usuario",
  templateUrl: "./selecao-tipo-usuario.component.html",
  styleUrls: ["./selecao-tipo-usuario.component.scss"],
})
export class SelecaoTipoUsuarioComponent {
  constructor(private location: Location) {}
  @Output() tipoSelecionado = new EventEmitter<InvestorType>();
  @Input() deveExibirAlertaPF = true;

  isInvestidor: boolean = false;

  setType(param: number) {
    switch (param) {
      case 1: {
        this.isInvestidor = true;
        break;
      }
      case 2: {
        this.tipoSelecionado.emit(InvestorType.Entity);
        break;
      }
    }
  }

  setForm(param: number) {
    switch (param) {
      case 1: {
        this.exibirAlertaPF();
        break;
      }
      case 2: {
        this.tipoSelecionado.emit(InvestorType.PJ);
        break;
      }
      case 3: {
        this.tipoSelecionado.emit(InvestorType.Investment);
        break;
      }
    }
  }

  backStep() {
    this.isInvestidor = false;
  }

  voltarInicio() {
    this.location.back();
  }

  private exibirAlertaPF() {
    if (!this.deveExibirAlertaPF) {
      this.tipoSelecionado.emit(InvestorType.PF);
      return;
    }

    Swal.fire({
      title: "Atenção",
      html: `
        Este é um canal exclusivo para Pessoa Jurídica ou Pessoa Física - Garantia Especial (DPGE). Para se cadastrar como Pessoa Física,
        solicitar ou acompanhar o status da sua solicitação de Garantia Ordinária, baixe e acesse o APP FGC (Disponível em todas lojas de aplicativos mobile)
        <br>
        <br>
        <br>
        <p class="info-text">Em caso de dúvidas, encaminhe um email para: <a href="mailto: atendimento.credores@fgc.org.br" target="_blank"> atendimento.credores@fgc.org.br  </a></p>
      `,
      confirmButtonText: "Estou de acordo",
      showCloseButton: true,
      padding: "2em",
      width: "900px",
      denyButtonText: "Quero solicitar, garantia ordinária",
    }).then((res) => {
      if (res.isConfirmed) {
        this.tipoSelecionado.emit(InvestorType.PF);
      } else if (res.isDismissed || res.isDenied) {
        return;
      }
    });
  }
}
